<script lang="ts">
    import ContentBlock from "./ContentBlock.svelte"

    let { product }: { product: Product } = $props()
</script>

<ContentBlock
    block={{
        type: "productList",
        hide: false,
        title: "Es gibt noch mehr zu entdecken",
        background: "light",
        width: "normal",
        "margin-top": "normal",
        "margin-bottom": "normal",
        productList: {
            type: "relatedCodes",
            relatedCodes: product.related_codes,
        },
    }}
/>
